import { post } from './_defaults/fetch.js';

export const subscribeNewsletter = async ({data, config}) => post('/newsletter/subscribe', data, config);